const PropTypes = require('prop-types');

//eslint-disable-next-line no-unused-vars
const Column = ({ dataKey, format, header }) => null;

Column.propTypes = {
    dataKey: PropTypes.string,
    format: PropTypes.func,
    header: PropTypes.string,
};

module.exports = Column;
